export default __webpack_public_path__ + "static/media/ij_circle.3a85d919.png";